// extracted by mini-css-extract-plugin
export default {"body":"main_body__+epEh","main":"main_main__CavUX"};